

export class AlertUpdateInput implements IAlertUpdateInput {
    /** The auto-generated id of the alert master */
    alertId!: number;
    /** The alert name with 255 character limit */
    alertName!: string;

    constructor(data?: IAlertUpdateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alertId = _data["alertId"];
            this.alertName = _data["alertName"];
        }
    }

    static fromJS(data: any): AlertUpdateInput {
        data = typeof data === 'object' ? data : {};
        let result = new AlertUpdateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alertId"] = this.alertId;
        data["alertName"] = this.alertName;
        return data; 
    }
}

export interface IAlertUpdateInput {
    /** The auto-generated id of the alert master */
    alertId: number;
    /** The alert name with 255 character limit */
    alertName: string;
}

